import * as actions from './actions'
import * as actionTypes from './actionTypes'
import reducer from './reducer'
import * as selectors from './selectors'
import * as types from './types'

console.log('Files feature initialized!')

export { actions, actionTypes, reducer, selectors, types }
